import React from 'react'
import { Link } from 'react-router-dom'
import Moment from 'moment';
export default function LatestBlog(props) {
    const post = props.post
    return (
        <article className="item">
            <Link to={`/blog/posts/${post.id}`} className="thumb">
                <span className="fullimage cover bg1" role="img" style={{backgroundImage: post.image}}></span>
            </Link>
            <div className="info">
                <time dateTime={post.date}>{Moment(Date(post.date)).format('MMMM DD, YYYY')}</time>
                <h4 className="title usmall">
                <Link to={`/blog/posts/${post.id}`}>{post.title}</Link>
                </h4>
            </div>

            <div className="clear"></div>
        </article>
    )
}
